import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";

function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`site-header${scrolled ? " is-scrolled" : ""}`}>
      <div className="container header-inner">
        <Link to="/" className="brand" onClick={closeMenu}>
          <img
            src={`${process.env.PUBLIC_URL}/logo.png`}
            alt="The Way 5:23"
            className="brand-logo"
          />
        </Link>

        <div className="header-actions">
          <button
            className={`nav-toggle${menuOpen ? " is-open" : ""}`}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span />
            <span />
            <span />
          </button>

          <nav className={`site-nav${menuOpen ? " is-open" : ""}`}>
            <NavLink to="/" end onClick={closeMenu}>
              Home
            </NavLink>
            <a href="/#features" onClick={closeMenu}>
              Features
            </a>
            <a href="/#how-it-works" onClick={closeMenu}>
              How It Works
            </a>
            <a href="/#stewardship" onClick={closeMenu}>
              Stewardship
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default SiteHeader;
